import { geonameService } from "@/_services";

export const geoname = {
  namespaced: true,
  state: {
    paises: {
      data: [],
      status: {},
    },
    provinces: {
      data: [],
      status: {},
    },
    list: {
      data: {},
      status: {},
    },
    entity: {
      data: {},
      status: {},
    },
    update: {
      data: {},
      status: {},
    },
    delete: {
      data: {},
      status: {},
    },
    create: {
      data: {},
      status: {},
    },
  },
  mutations: {
    getPaisesRequest(state) {
      state.paises.status = {
        loading: true,
      };
    },
    getPaisesError(state, error) {
      state.paises.data = [];
      state.paises.status = {
        error,
      };
    },
    getPaisesSuccess(state, paises) {
      state.paises.data = paises;
      state.paises.status = {
        loaded: true,
      };
    },
    getProvincesRequest(state) {
      state.provinces.status = {
        loading: true,
      };
    },
    getProvincesError(state, error) {
      state.provinces.data = [];
      state.provinces.status = {
        error,
      };
    },
    getProvincesSuccess(state, provinces) {
      state.provinces.data = provinces;
      state.provinces.status = {
        loaded: true,
      };
    },
    getAllRequest(state) {
      state.list.status = {
        loading: true,
      };
    },
    getAllError(state, error) {
      state.list.data = [];
      state.list.status = {
        error,
      };
    },
    getAllSuccess(state, list) {
      state.list.data = list;
      state.list.status = {
        loaded: true,
      };
    },
    getByIdRequest(state) {
      state.entity.status = {
        loading: true,
      };
    },
    getByIdError(state, error) {
      state.entity.data = [];
      state.entity.status = {
        error,
      };
    },
    getByIdSuccess(state, entity) {
      state.entity.data = entity;
      state.entity.status = {
        loaded: true,
      };
    },
    updateRequest(state) {
      state.update.status = {
        updating: true,
      };
    },
    updateError(state, error) {
      state.update.data = [];
      state.update.status = {
        error,
      };
    },
    updateSuccess(state, update) {
      state.update.data = update;
      state.update.status = {
        updated: true,
      };
    },
    deleteRequest(state) {
      state.delete.status = {
        deleting: true,
      };
    },
    deleteError(state, error) {
      state.delete.data = [];
      state.delete.status = {
        error,
      };
    },
    deleteSuccess(state, data) {
      state.delete.data = data;
      state.delete.status = {
        deleted: true,
      };
    },

    createRequest(state) {
      state.create.status = {
        creating: true,
      };
    },
    createError(state, error) {
      state.create.data = [];
      state.create.status = {
        error,
      };
    },
    createSuccess(state, data) {
      state.create.data = data;
      state.create.status = {
        created: true,
      };
    },
  },
  actions: {
    getPaises({ commit }, filters) {
      commit("getPaisesRequest");
      geonameService
        .getPaises(filters)
        .then((paises) => {
          commit("getPaisesSuccess", paises);
        })
        .catch((error) => {
          commit("getPaisesError", error);
        });
    },
    getProvinces({ commit }, filters) {
      commit("getProvincesRequest");
      geonameService
        .getProvinces(filters)
        .then((provincias) => {
          commit("getProvincesSuccess", provincias);
        })
        .catch((error) => {
          commit("getProvincesError", error);
        });
    },
    getAll({ commit }, { pagination, query }) {
      commit("getAllRequest");
      geonameService
        .getAll(pagination, query)
        .then((list) => {
          commit("getAllSuccess", list);
        })
        .catch((error) => {
          commit("getAllError", error);
        });
    },
    getById({ commit }, geonameId) {
      commit("getByIdRequest");
      geonameService
        .getById(geonameId)
        .then((entity) => {
          commit("getByIdSuccess", entity);
        })
        .catch((error) => {
          commit("getByIdError", error);
        });
    },
    updateById({ commit }, { id, body }) {
      commit("updateRequest");
      geonameService
        .updateById(id, body)
        .then((update) => {
          commit("updateSuccess", update);
        })
        .catch((error) => {
          commit("updateError", error);
        });
    },
    deleteById({ commit }, geonameId) {
      commit("deleteRequest");
      geonameService
        .deleteById(geonameId)
        .then((data) => {
          commit("deleteSuccess", data);
        })
        .catch((error) => {
          commit("deleteError", error);
        });
    },
    create({ commit }, data) {
      commit("createRequest");
      geonameService
        .create(data)
        .then((create) => {
          commit("createSuccess", create);
        })
        .catch((error) => {
          commit("createError", error);
        });
    },
  },
};
